
import { Input } from "@/components/ui/input";

interface ContactInformationProps {
  firstName: string;
  lastName: string;
  phone: string;
  deliveryType: "delivery" | "pickup";
  onFirstNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLastNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ContactInformation = ({
  firstName,
  lastName,
  phone,
  deliveryType,
  onFirstNameChange,
  onLastNameChange,
  onPhoneChange,
}: ContactInformationProps) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Contact Information</h2>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">First Name</label>
          <Input 
            required 
            value={firstName}
            onChange={onFirstNameChange}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Last Name</label>
          <Input 
            required 
            value={lastName}
            onChange={onLastNameChange}
          />
        </div>
      </div>
      <div className="mt-4">
        <label className="block text-sm font-medium mb-1">Phone</label>
        <Input 
          type="tel" 
          required 
          value={phone}
          onChange={onPhoneChange}
        />
      </div>
      {deliveryType === "pickup" && (
        <div className="mt-4 p-4 bg-muted rounded-lg">
          <p className="text-sm text-muted-foreground">
            Pickup information will be provided to you upon successful payment.
          </p>
        </div>
      )}
    </div>
  );
};
